import {connect} from "react-redux";
import {getCart, removeBeneficiary} from "../../../../actions/action";
import {getCartListAction} from "../../../../actions";
import Checkout from '../component/Checkout';
import { Toaster, Intent, Position } from '@blueprintjs/core';


const mapStateToProps = state =>{

    return{
        ggCartList: state.homeThyro.ggCartList
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        getCart : () =>{
            getCart()
                .then((res)=>{
                    let resource = res.data;
                    if(resource.status){
                        dispatch(getCartListAction(resource.data))
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status !== 401) {
                        Object.keys(error.response.data.error).forEach((key) => {
                            error.response.data.error[key].forEach((error) => {
                                Toaster.create({position: Position.TOP}).show({
                                    message: error,
                                    intent: Intent.DANGER
                                });
                            });
                        });
                    }
                });

        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkout)